export const CUSTOM_TYPES = [
  { value: "text", label: "Short text" },
  { value: "textarea", label: "Long text" },
  { value: "number", label: "Number" },
  { value: "date", label: "Date" },
  { value: "select", label: "Dropdown (pick one)" },
  { value: "multi", label: "Multiple choice (pick several)" },
  { value: "checkbox", label: "Checkbox (yes / no)" },
  { value: "email", label: "Email" },
  { value: "phone", label: "Phone number" },
];

export const TYPE_LABEL = {
  ...Object.fromEntries(CUSTOM_TYPES.map((t) => [t.value, t.label])),
  title: "Title list", sex: "Male / Female", region: "Region list", pin: "AHPC PIN", account_email: "Account email", member_id: "Membership ID",
};

export const hasOptions = (t) => t === "select" || t === "multi";

const rid = () => Math.random().toString(36).slice(2, 10).padEnd(8, "0");
export const newKey = () => `cf_${rid()}`;
export const newSectionId = () => `s-${rid()}`;

const clone = (form) => ({ sections: form.sections.map((s) => ({ ...s, fields: [...s.fields] })) });

export const moveSection = (form, i, dir) => {
  const f = clone(form);
  const j = i + dir;
  if (j < 0 || j >= f.sections.length) return form;
  [f.sections[i], f.sections[j]] = [f.sections[j], f.sections[i]];
  return f;
};

export const moveField = (form, si, fi, dir) => {
  const f = clone(form);
  const list = f.sections[si].fields;
  const fj = fi + dir;
  if (fj >= 0 && fj < list.length) {
    [list[fi], list[fj]] = [list[fj], list[fi]];
    return f;
  }
  const sj = si + dir;
  if (sj < 0 || sj >= f.sections.length) return form;
  const [field] = list.splice(fi, 1);
  if (dir < 0) f.sections[sj].fields.push(field); else f.sections[sj].fields.unshift(field);
  return f;
};

export const removeField = (form, si, fi) => {
  const f = clone(form);
  f.sections[si].fields.splice(fi, 1);
  return f;
};

export const upsertField = (form, si, field, origKey) => {
  const f = clone(form);
  const from = f.sections.findIndex((s) => s.fields.some((x) => x.key === (origKey || field.key)));
  if (from === si) {
    f.sections[si].fields = f.sections[si].fields.map((x) => (x.key === (origKey || field.key) ? field : x));
    return f;
  }
  if (from >= 0) f.sections[from].fields = f.sections[from].fields.filter((x) => x.key !== (origKey || field.key));
  f.sections[si].fields.push(field);
  return f;
};

export const setSection = (form, si, patch) => {
  const f = clone(form);
  f.sections[si] = { ...f.sections[si], ...patch };
  return f;
};

export const addSection = (form, title) => ({ sections: [...clone(form).sections, { id: newSectionId(), title, fields: [] }] });

export const removeSection = (form, si) => ({ sections: clone(form).sections.filter((_, i) => i !== si) });
